import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Button from "../../../../components/Button";
import customSelectStyles from "components/CustomSelect/CustomSelectStyle";
import Select from "react-select";
import InputField from "../../../../components/InputField";
import { getDrugById, updateDrugInfo, getAllMasterServicesDetails } from "core/services/api";
import "./Wondersoft.scss";
import Toast from "components/Toast";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

function EditDrug() {

  const history = useHistory()
  const { id }: any = useParams()
  const [formErrors, setFormErrors] = useState<any>()
  const [drugInfo, setDrugInfo] = useState<any>({
    id: "",
    dpco: "",
    brandName: "",
    genericName: "",
    drugType: "",
    sideEffects: [],
    services: [],
    highRisk: false,
    productCode: "",
    alternateProductCode: "",
    upperLimit: ""
  })
  const [sideEffectInput, setSideEffectInput] = useState<string>('')
  const [isSubmit, setIsSubmit] = useState(false)
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [success, setSuccess] = useState<boolean>(false)
  const [services, setServices] = useState<any>([])
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  useEffect(() => {
    getAdminServices()
  }, [])

  useEffect(() => {
    if (services && services.length > 0) {
      fetchDrugDetailById()
    }
  }, [services])

  function getAdminServices() {
    const query = `services`
    getAllMasterServicesDetails(query)
      .then((res) => {
        setServices(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const fetchDrugDetailById = () => {
    if (id) {
      getDrugById(id)
        .then((res) => {
          const selectedServices = res?.services?.map((serviceId: string) => {
            const service = services?.find((s: any) => s?.id === serviceId);
            return {
              label: service?.name,
              value: service?.id,
            };
          }) || [];

          setDrugInfo({
            id: res?.id,
            dpco: res?.dpco,
            brandName: res?.brandName,
            genericName: res?.genericName,
            drugType: res?.drugType,
            sideEffects: res?.sideEffects,
            services: selectedServices,
            highRisk: res?.highRisk,
            productCode: res?.productCode,
            alternateProductCode: res?.alternateProductCode,
            upperLimit: res?.upperLimit
          })
        })
        .catch((err) => {
          console.log("Err,", err)
        })
    }
  }

  const validate = (values: any) => {
    const errors: any = {}

    return errors
  }

  const handleAddSideEffect = () => {
    if (sideEffectInput.trim()) {
      setDrugInfo({
        ...drugInfo,
        sideEffects: [...(drugInfo?.sideEffects || []), sideEffectInput.trim()]
      })
      setSideEffectInput('')
    }
  }

  const handleRemoveSideEffect = (index: number) => {
    setDrugInfo({
      ...drugInfo,
      sideEffects: drugInfo?.sideEffects?.filter((_: string, i: number) => i !== index)
    })
  }

  useEffect(() => {
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      let test: any = {
        id: drugInfo?.id,
        dpco: drugInfo?.dpco,
        brandName: drugInfo?.brandName,
        genericName: drugInfo?.genericName,
        drugType: drugInfo?.drugType,
        sideEffects: drugInfo?.sideEffects,
        services: drugInfo?.services?.map((service: any) => service?.value),
        highRisk: drugInfo?.highRisk,
        productCode: drugInfo?.productCode,
        alternateProductCode: drugInfo?.alternateProductCode,
        upperLimit: drugInfo?.upperLimit
      }
      setIsLoading(true)

      updateDrugInfo(id, test)
        .then((data) => {
          setIsLoading(false)
          setMessage("Drug Updated Successfully")
          setToastType("success")
          setSuccess(true)
        })
        .catch((err: any) => {
          setIsLoading(false)
          setMessage(err?.response?.data?.message)
          setToastType("error")
          setSuccess(true)
        })
    }
  }, [formErrors])


  const handleSubmit = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    setFormErrors(validate(drugInfo))
    setIsSubmit(true)
  }

  return (
    <div className="edit-manage-staff-wrapper">

      {success ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
              if (toastType !== "error") {
                history.push(`/wondersoft`)
              }
            }}
            type={toastType}
          ></Toast></>
      ) : isLoading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      ) : (
        ""
      )}

      <div
        className="approval-back-image"
        onClick={() => {
          history.push("/wondersoft")
        }}
      >
        <img
          src={"../../../assets/images/back-icon.svg"}
          height={"60px"}
          width={"60px"}
          alt="back button"
          className="back_button"
        />
        <div className="edit-manage-staff-heading">Edit Drug</div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="edit-details-wrapper">
          <div className="edit-details-container">
            <div className="manage-staff-details" style={{ paddingRight: 16 }}>
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel"> Generic Name:</label>
                </div>
                <InputField
                  placeholder="Name"
                  readOnly={true}
                  value={drugInfo?.genericName}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">  Drug Type:</label>
                </div>
                <InputField
                  placeholder="Drug Type"
                  readOnly={true}
                  value={drugInfo?.drugType}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">  Brand Name:</label>
                </div>
                <InputField
                  readOnly={true}
                  value={drugInfo?.brandName ? drugInfo?.brandName : ""}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">  DPCO:</label>
                </div>
                <InputField
                  placeholder="DPCO"
                  readOnly={true}
                  value={drugInfo?.dpco}
                />
              </div>
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel"> Services:</label>
                </div>
                <Select
                  styles={customSelectStyles()}
                  value={drugInfo?.services}
                  onFocus={() => setIsMenuOpen(true)}
                  onBlur={() => setIsMenuOpen(false)}
                  menuIsOpen={isMenuOpen}
                  placeholder="Select services"
                  options={services?.map((service: any) => ({
                    label: service?.name,
                    value: service?.id,
                  }))}
                  isMulti
                  onChange={(option: any) => {
                    let filteredArray = [...option];
                    setDrugInfo({
                      ...drugInfo,
                      services: filteredArray,
                    })
                  }}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">  Upper Limit:</label>
                </div>
                <InputField
                  value={drugInfo?.upperLimit ? drugInfo?.upperLimit : ""}
                  placeholder="Enter upper limit"
                  handleChange={(e) => setDrugInfo({
                    ...drugInfo,
                    upperLimit: e.target.value,
                  })}
                />
              </div>

              {/* Side Effects Field */}
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">Side Effect:</label>
                </div>

                {/* Side Effects Input with Tags */}
                <div className="side-effects-input-container">
                  <div className="side-effects-tags-wrapper">
                    {drugInfo?.sideEffects?.map((effect: string, index: number) => (
                      <div key={index} className="side-effect-tag-inline">
                        <span>{effect}</span>
                        <button
                          type="button"
                          onClick={() => handleRemoveSideEffect(index)}
                          className="btn-remove-inline"
                          title="Remove"
                        >
                          ×
                        </button>
                      </div>
                    ))}

                    <div className="d-flex flex-row align-items-center mt-2 side-effects-input-row">
                      <InputField
                        className="side-effect-input"
                        placeholder="Enter side effect"
                        value={sideEffectInput}
                        handleChange={(e) => setSideEffectInput(e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={handleAddSideEffect}
                        className="btn btn-primary side-effect-add-btn"
                      >
                        Add
                      </button>
                    </div>
                  </div>

                </div>

                {formErrors?.sideEffects && (
                  <span className="error-message">{formErrors.sideEffects}</span>
                )}
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div className="d-flex align-items-center"
                  role="button"
                  onClick={() => {
                    setDrugInfo({
                      ...drugInfo,
                      highRisk: !drugInfo?.highRisk,
                    })
                  }}>
                  <div>
                    <label className="textlabel"> High Risk:</label>
                  </div>
                  <div>
                    {drugInfo?.highRisk ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                  </div>
                </div>
              </div>

            </div>
            <div className="button-alignment">
              <div>
                <Button
                  text="Cancel"
                  type={"button"}
                  outline={true}
                  onClick={() => history.push(`/wondersoft`)}
                  id="cancel"
                />
              </div>

              <div>
                <Button
                  text={"Update"}
                  type="submit"
                  id="save"
                />
              </div>

            </div>
          </div>
        </div>
      </form >
    </div>
  )
}

export default EditDrug;